import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, CheckCheck, Package, MessageCircle, UserCheck } from "lucide-react";
import { api } from "@/lib/api";
import { Loader, Empty } from "@/components/shared";

const ICON = { order: Package, message: MessageCircle, account: UserCheck };

export default function Notifications() {
  const [items, setItems] = useState(null);
  const nav = useNavigate();

  const load = () => api.get("/notifications").then(({ data }) => setItems(data.items));
  useEffect(() => { load(); }, []);

  const readAll = async () => { await api.post("/notifications/read-all"); load(); };
  const click = async (n) => {
    if (!n.read) await api.post(`/notifications/${n.id}/read`);
    if (n.link) nav(n.link);
  };

  if (items === null) return <Loader />;
  return (
    <div className="mx-auto max-w-2xl px-4 sm:px-6 py-8">
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-head text-2xl font-black text-white flex items-center gap-2"><Bell size={24} /> الإشعارات</h1>
        {items.length > 0 && <button data-testid="mark-all-read" onClick={readAll} className="flex items-center gap-1 text-sm text-[var(--amber)]"><CheckCheck size={16} /> تعليم الكل كمقروء</button>}
      </div>
      {items.length === 0 ? <Empty text="لا توجد إشعارات." /> : (
        <div className="space-y-2">
          {items.map((n) => {
            const Icon = ICON[n.type] || Bell;
            return (
              <button key={n.id} data-testid={`notif-${n.id}`} onClick={() => click(n)}
                className={`w-full text-right ts-card p-4 flex gap-3 items-start ${!n.read ? "border-r-4" : ""}`}
                style={!n.read ? { borderRightColor: "var(--amber)" } : {}}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[var(--amber)]/10 text-[var(--amber)]"><Icon size={18} /></span>
                <div className="flex-1">
                  <p className="font-bold text-white text-sm">{n.title}</p>
                  <p className="text-xs text-[var(--text-muted)] mt-0.5">{n.body}</p>
                </div>
                {!n.read && <span className="h-2 w-2 rounded-full bg-[var(--amber)] mt-1.5" />}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
